export default "__VITE_ASSET__DVsr6HcR__"